// Mirrors apps/angular/src/js/ng/common/constants/dayTime.constant.js.
// `id` values are the API's time-of-day identifiers sent as
// `{day}Availability=1,2` comma-joined strings (1 = morning, 2 = afternoon,
// 3 = night).

export interface DayOfWeek {
  id: number;
  code: string;
  short: string;
  name: string;
  filterKey:
    | 'sundayAvailability'
    | 'mondayAvailability'
    | 'tuesdayAvailability'
    | 'wednesdayAvailability'
    | 'thursdayAvailability'
    | 'fridayAvailability'
    | 'saturdayAvailability';
}

export interface TimeOfDay {
  id: number;
  code: 'MORNING' | 'AFTERNOON' | 'NIGHT';
  name: string;
}

export const DAYS_OF_WEEK: DayOfWeek[] = [
  { id: 1, code: 'SUN', short: 'S', name: 'Sunday', filterKey: 'sundayAvailability' },
  { id: 2, code: 'MON', short: 'M', name: 'Monday', filterKey: 'mondayAvailability' },
  { id: 3, code: 'TUE', short: 'T', name: 'Tuesday', filterKey: 'tuesdayAvailability' },
  { id: 4, code: 'WED', short: 'W', name: 'Wednesday', filterKey: 'wednesdayAvailability' },
  { id: 5, code: 'THU', short: 'T', name: 'Thursday', filterKey: 'thursdayAvailability' },
  { id: 6, code: 'FRI', short: 'F', name: 'Friday', filterKey: 'fridayAvailability' },
  { id: 7, code: 'SAT', short: 'S', name: 'Saturday', filterKey: 'saturdayAvailability' },
];

export const TIMES_OF_DAY: Record<'MORNING' | 'AFTERNOON' | 'NIGHT', TimeOfDay> = {
  MORNING: { id: 1, code: 'MORNING', name: 'Morning' },
  AFTERNOON: { id: 2, code: 'AFTERNOON', name: 'Afternoon' },
  NIGHT: { id: 3, code: 'NIGHT', name: 'Night' },
};

// Mirrors search.constant.js `lastAccess`.
export const LAST_ACCESS_OPTIONS: Array<{ value: string; label: string }> = [
  { value: '', label: 'Any time' },
  { value: '1', label: 'Today' },
  { value: '7', label: 'Past week' },
  { value: '30', label: 'Past month' },
  { value: '90', label: 'Past 3 months' },
];

// Mirrors search.constant.js `facilityTypes`.
export const FACILITY_TYPES: Array<{ value: string; label: string }> = [
  { value: '', label: 'All types' },
  { value: 'center', label: 'Center based' },
  { value: 'homebased', label: 'Home based' },
];

// Mirrors specialService.constant.js — used to decide whether to show the
// Outschool widget when user has filtered by "homework assistance / tutoring".
export const HOMEWORK_ASSISTANCE_TUTORING_ID = 9;

export const VERTICAL_CHILD_CARE_ID = 1;
export const VERTICAL_DAY_CARE_ID = 7;

// Recurring search type codes — availability filter + background-check CTA +
// availability widgets all only appear when one of these is selected.
export const RECURRING_SEARCH_TYPE_CODES = new Set([
  'FULL_TIME',
  'PART_TIME',
  'AFTER_SCHOOL',
]);
